import React, { useRef, useState, useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react'

//Animation
import { useAutoAnimate } from '@formkit/auto-animate/react'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Skeleton
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

//ICONS
import { BsCheck2Circle, BsXLg, BsPencil, BsTrash, BsFillExclamationTriangleFill, BsInfoCircle } from "react-icons/bs";

//APIS
import { anabilimanasanat, anabilimanasanatCreate, anabilimanasanatUpdate } from '../../../apis/anabilimanasanat';
import { bilimsanat, bilimsanatCreate, bilimsanatUpdate } from '../../../apis/bilimsanat';

//HELPERS
import upperCase from '../../../helpers/upperCase';

const Tanimlar = () => {
    const reduxData = useSelector((state) => state.auth)

    const [animationParent] = useAutoAnimate()
    const [loading, setLoading] = useState(false) // Skleton için kullanılacak
    const [loading2, setLoading2] = useState(false) // Skleton için kullanılacak

    const [form1, setForm1] = useState(false) // false yeni kayıt true düzenleme anabilim/anasanat dalı formu
    const [form2, setForm2] = useState(false) // false yeni kayıt true düzenleme bilim/sanat dalı formu

    const [form1Sil, setForm1Sil] = useState(false)
    const [form2Sil, setForm2Sil] = useState(false)



    //REFS
    const anaBilimAnaSanatDaliRef = useRef()
    const bilimSanatDaliRef = useRef()



    //STATES FORM 1
    const [anaBilimAnaSanatDaliSelectedIdSec, setAnaBilimAnaSanatDaliSelectedIdSec] = useState({ id: 0, name: "" })
    const [anaBilimAnaSanatDali, setAnaBilimAnaSanatDali] = useState("")
    const [anaBilimAnaSanatDaliSelectedId, setAnaBilimAnaSanatDaliSelectedId] = useState()

    //STATES FORM 2
    const [bilimSanatDali, setBilimSanatDali] = useState("")
    const [bilimSanatDaliSelectedId, setBilimSanatDaliSelectedId] = useState("")



    //LIST STATES
    const [anaBilimAnaSanatDaliLIST, setAnaBilimAnaSanatDaliLIST] = useState([])
    const [bilimSanatDaliLIST, setBilimSanatDaliLIST] = useState([])

    //HANDLE FORM1 FUNCTIONS
    const handleForm1Control = () => {
        if (anaBilimAnaSanatDali === "") {
            anaBilimAnaSanatDaliRef.current.focus()
            return toast.error("Anabilim/Anasanat Dalı adını giriniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }

        if (form1 === false) {
            //Yeni Kayıt
            handleForm1Save()
        } else {
            //Kayıt Düzenleme
            handleForm1Update()
        }
    }

    const handleForm1Save = async () => {
        let data = {
            enstituId: reduxData.userEnstituId,
            anabilimName: upperCase(anaBilimAnaSanatDali)
        }

        let result = await anabilimanasanatCreate(data)
        console.log(result)
        if (result.status === 200) {
            toast.success("Kayıt eklendi", {
                position: toast.POSITION.TOP_RIGHT
            });
            getAnabilimAnaSanatDaliLIST()
            handleForm1Clear()
        }
    }

    const handleForm1Update = async () => {
        let data = {
            anabilimName: upperCase(anaBilimAnaSanatDali)
        }

        let result = await anabilimanasanatUpdate(anaBilimAnaSanatDaliSelectedId, data)
        console.log(result)
        if (result.status === 200) {
            toast.success("Kayıt güncellendi", {
                position: toast.POSITION.TOP_RIGHT
            });
            getAnabilimAnaSanatDaliLIST()
            handleForm1Clear()
        }
    }

    const handleForm1Delete = async () => {
        let data = {
            anabilimIsDelete: true
        }

        let result = await anabilimanasanatUpdate(anaBilimAnaSanatDaliSelectedId, data)
        if (result.status === 200) {
            toast.success("Kayıt silindi", {
                position: toast.POSITION.TOP_RIGHT
            });
            getAnabilimAnaSanatDaliLIST()
            handleForm1Clear()
        } else {
            handleForm1Clear()
            return toast.error(result.response.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }

    }

    const handleForm1Clear = () => {
        setForm1(false)
        setForm1Sil(false)
        setAnaBilimAnaSanatDali("")
        setAnaBilimAnaSanatDaliSelectedId()
    }

    //HANDLE FORM2 DUNCTIONS

    const handleForm2Control = () => {
        if (bilimSanatDali === "") {
            bilimSanatDaliRef.current.focus()
            return toast.error("Bilim/Sanat Dalı adını giriniz", {
                position: toast.POSITION.TOP_RIGHT
            });
        }

        if (form2 === false) {
            //Yeni Kayıt
            handleForm2Save()
        } else {
            //Kayıt Düzenleme
            handleForm2Update()
        }
    }

    const handleForm2Save = async () => {
        let data = {
            anabilimId: anaBilimAnaSanatDaliSelectedIdSec.id,
            bilimsanatdaliName: upperCase(bilimSanatDali)
        }

        let result = await bilimsanatCreate(data)
        console.log(result)
        if (result.status === 200) {
            toast.success("Kayıt eklendi", {
                position: toast.POSITION.TOP_RIGHT
            });
            getBilimSanatDaliLIST()
            handleForm2Clear()
        }
    }

    const handleForm2Update = async () => {
        let data = {
            bilimsanatdaliName: upperCase(bilimSanatDali)
        }

        let result = await bilimsanatUpdate(bilimSanatDaliSelectedId, data)
        if (result.status === 200) {
            toast.success("Kayıt güncellendi", {
                position: toast.POSITION.TOP_RIGHT
            });
            getBilimSanatDaliLIST()
            handleForm2Clear()
        }
    }

    const handleForm2Delete = async () => {
        let data = {
            bilimsanatdaliIsDelete: true
        }

        let result = await bilimsanatUpdate(bilimSanatDaliSelectedId, data)
        if (result.status === 200) {
            toast.success("Kayıt silindi", {
                position: toast.POSITION.TOP_RIGHT
            });
            getBilimSanatDaliLIST()
            handleForm2Clear()
        } else {
            handleForm2Clear()
            return toast.error(result.response.data.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    }


    const handleForm2Clear = () => {
        setForm2(false)
        setForm2Sil(false)
        setBilimSanatDali("")
        setBilimSanatDaliSelectedId()
    }


    //FUNCTIONS
    const getAnabilimAnaSanatDaliLIST = async () => {
        let result = await anabilimanasanat()
        if (result.status === 200) {
            setAnaBilimAnaSanatDaliLIST(result.data)
            setLoading(false)
        }
    }

    const getBilimSanatDaliLIST = async () => {
        setLoading2(true)
        let result = await bilimsanat()
        //console.log(result.data)
        if (result.status === 200) {
            setBilimSanatDaliLIST(result.data)
            setLoading2(false)
        }
    }



    useEffect(() => {
        setLoading(true)
        getAnabilimAnaSanatDaliLIST()
        getBilimSanatDaliLIST()
    }, []);

    return (
        <>
            <ToastContainer />
            <main className='text-slate-500 text-sm transition-all'>
                <div className="py-5">
                    <div className="w-full px-4 sm:px-6 md:px-8">
                        <div className='container mx-auto'>
                            <h1 className='page-title leading-6 font-normal text-lg mb-6 text-slate-500'>Tanımlar</h1>
                        </div>
                        <div className='container mx-auto space-y-4'>
                            <div className='kapsama relative w-full flex flex-col lg:flex-row gap-4'>

                                {/* ANABİLİM/ANASANAT DALI*/}
                                <div className='w-full lg:w-6/12'>
                                    <div className='bg-white rounded-lg p-4 min-h-0'>
                                        <h1 className='text-lg text-slate-950 mb-4'>Anabilim / Ana Sanat Dalı</h1>
                                        <div className='flex flex-col items-start gap-4 mb-6'>
                                            <div className='w-full flex items-end gap-x-2'>
                                                <div className='flex-auto space-y-4 text-slate-500'>
                                                    <div>
                                                        <label>Yeni Kayıt</label>
                                                        <input ref={anaBilimAnaSanatDaliRef} value={anaBilimAnaSanatDali} onChange={(e) => setAnaBilimAnaSanatDali(e.target.value)} type='text' placeholder='' className='w-full border border-slate-300   text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>
                                                </div>
                                                <div className='text-right'>
                                                    <button
                                                        onClick={() => handleForm1Control()}
                                                        disabled={anaBilimAnaSanatDali === "" ? true : false}
                                                        className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-slate-500 disabled:bg-slate-300  hover:bg-slate-500/80 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                        <BsCheck2Circle className='text-lg' />
                                                        {form1 ? "DÜZENLE" : "KAYDET"}
                                                    </button>
                                                </div>
                                                <div className='text-right'>
                                                    <button
                                                        onClick={() => handleForm1Clear()}
                                                        disabled={anaBilimAnaSanatDali === "" ? true : false}
                                                        className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-red-400 disabled:bg-red-300 hover:bg-red-500 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                        <BsXLg className='text-lg' />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <h1 className='text-slate-950 mb-4'>Kayıtlı Anabilim/Anasanat Dalları</h1>



                                        <div className='w-full'>
                                            <ul className='flex flex-col text-xs'>
                                                <div ref={animationParent}>
                                                    {
                                                        loading ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                            anaBilimAnaSanatDaliLIST?.filter(item => item.enstituId === reduxData.userEnstituId).map((item, key) => (
                                                                <li key={key} className='w-full mb-2 bg-slate-100 hover:bg-slate-200 hover:cursor-pointer rounded-md p-2 flex flex-col space-y-1 md:flex-row md:items-center md:space-x-4'>
                                                                    <button
                                                                        onClick={(e) => {
                                                                            setAnaBilimAnaSanatDaliSelectedIdSec({ id: item.anabilimId, name: item.anabilimName })
                                                                        }}
                                                                        className='w-10 text-xs text-white bg-teal-600 border-transparent border hover:bg-teal-600/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-teal-400'>
                                                                        Seç
                                                                    </button>
                                                                    <div className='flex-1'>{item.anabilimName}</div>

                                                                    <div className='flex-1 md:text-right space-x-4'>
                                                                        <button
                                                                            onClick={(e) => {
                                                                                setForm1(true)
                                                                                setAnaBilimAnaSanatDali(item.anabilimName)
                                                                                setAnaBilimAnaSanatDaliSelectedId(item.anabilimId)
                                                                            }}
                                                                            className='text-xs inline-flex items-center gap-x-1 text-white bg-slate-500 border-transparent border hover:bg-slate-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                            <BsPencil />Düzenle
                                                                        </button>
                                                                        <button
                                                                            onClick={() => {
                                                                                setAnaBilimAnaSanatDaliSelectedId(item.anabilimId)
                                                                                setForm1Sil(true)
                                                                            }}
                                                                            className='text-xs inline-flex items-center gap-x-1 text-white bg-red-500 border-transparent border hover:bg-red-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                                            <BsTrash />Sil
                                                                        </button>
                                                                    </div>
                                                                </li>
                                                            ))
                                                        )
                                                    }
                                                </div>
                                            </ul>
                                        </div>



                                    </div>

                                </div>
                                {/* BİLİM/SANAT DALI*/}
                                <div className='w-full lg:w-6/12'>
                                    <div className='bg-white rounded-lg p-4 min-h-0'>
                                        <h1 className='text-lg text-slate-950 mb-4'>Bilim / Sanat Dalı</h1>
                                        {
                                            anaBilimAnaSanatDaliSelectedIdSec.id === 0 ? (
                                                <div className="flex w-full overflow-hidden bg-white rounded-md border mb-2">
                                                    <div className="flex items-center justify-center w-[100px] bg-blue-500">
                                                        <BsInfoCircle className='text-2xl text-white' />
                                                    </div>

                                                    <div className="px-4 py-2 -mx-3">
                                                        <div className="mx-3">
                                                            <p className="text-xs">
                                                                Bilim/Sanat Dalı ekleme veya listeleme yapabilmeniz için <strong>Anabilim/Anasanat Dalı</strong> listesinde bulunan <strong>"Seç"</strong> butonuna tıklayınız.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className='flex flex-col items-start gap-4 mb-6'>
                                                        <div className='w-full flex items-end gap-x-2'>
                                                            <div className='flex-auto space-y-4 text-slate-500'>
                                                                <div>
                                                                    <label>Yeni Kayıt</label>
                                                                    <input ref={bilimSanatDaliRef} value={bilimSanatDali} onChange={(e) => setBilimSanatDali(e.target.value)} type='text' placeholder='' className='w-full border border-slate-300   text-sm h-10 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                                </div>
                                                            </div>
                                                            <div className='text-right'>
                                                                <button
                                                                    onClick={() => handleForm2Control()}
                                                                    disabled={bilimSanatDali === "" ? true : false}
                                                                    className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-slate-500 disabled:bg-slate-300  hover:bg-slate-500/80 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                    <BsCheck2Circle className='text-lg' />
                                                                    {form2 ? "DÜZENLE" : "KAYDET"}
                                                                </button>
                                                            </div>
                                                            <div className='text-right'>
                                                                <button
                                                                    onClick={() => handleForm2Clear()}
                                                                    disabled={bilimSanatDali === "" ? true : false}
                                                                    className='w-full text-xs h-10 inline-flex items-center gap-x-2 text-white bg-red-400 disabled:bg-red-300 hover:bg-red-500 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                                    <BsXLg className='text-lg' />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <h1>{anaBilimAnaSanatDaliSelectedIdSec.name}</h1>
                                                    <h1 className='text-slate-950 mb-4'>Kayıtlı Bilim/Sanat Dalları</h1>
                                                    <div className='w-full'>
                                                        <ul className='flex flex-col text-xs'>
                                                            <div ref={animationParent}>
                                                                {
                                                                    loading2 ? <Skeleton baseColor="#e2e8f0" width="100%" count={3} height={20} /> : (
                                                                        bilimSanatDaliLIST.filter(item => item.anabilimId === anaBilimAnaSanatDaliSelectedIdSec.id).length > 0 ? (
                                                                            bilimSanatDaliLIST?.filter(item => item.anabilimId === anaBilimAnaSanatDaliSelectedIdSec.id).map((item, key) => (
                                                                                <li key={key} className='w-full mb-2 bg-slate-100 hover:bg-slate-200 hover:cursor-pointer rounded-md p-2 flex flex-col space-y-1 md:flex-row md:items-center md:space-x-4'>

                                                                                    <div className='flex-1'>{item.bilimsanatdaliName}</div>

                                                                                    <div className='flex-1 md:text-right space-x-4'>
                                                                                        <button
                                                                                            onClick={(e) => {
                                                                                                setForm2(true)
                                                                                                setBilimSanatDali(item.bilimsanatdaliName)
                                                                                                setBilimSanatDaliSelectedId(item.bilimsanatdaliId)
                                                                                            }}
                                                                                            className='text-xs inline-flex items-center gap-x-1 text-white bg-slate-500 border-transparent border hover:bg-slate-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                                                            <BsPencil />Düzenle
                                                                                        </button>
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                setBilimSanatDaliSelectedId(item.bilimsanatdaliId)
                                                                                                setForm2Sil(true)
                                                                                            }}
                                                                                            className='text-xs inline-flex items-center gap-x-1 text-white bg-red-500 border-transparent border hover:bg-red-500/80 px-2 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-red-300 transition-all'>
                                                                                            <BsTrash />Sil
                                                                                        </button>
                                                                                    </div>
                                                                                </li>
                                                                            ))
                                                                        ) : (
                                                                            <div>Listelenecek kayıt bulunamamıştır.</div>
                                                                        )
                                                                    )
                                                                }
                                                            </div>
                                                        </ul>
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
            <Transition.Root show={form1Sil} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={setForm1Sil}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 "
                                            onClick={() => setForm1Sil(false)}
                                        >
                                            <span className="sr-only">Close</span>
                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <BsFillExclamationTriangleFill className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                UYARI!
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Seçili Anabilim/Anasanat Dalını Silmek Üzeresiniz. Emin misiniz?
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                            onClick={() =>
                                                handleForm1Delete()
                                            }
                                        >
                                            Evet
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => {
                                                setForm1Sil(false)
                                                setAnaBilimAnaSanatDaliSelectedId()
                                            }}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
            <Transition.Root show={form2Sil} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={setForm2Sil}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 "
                                            onClick={() => setForm2Sil(false)}
                                        >
                                            <span className="sr-only">Close</span>
                                            <BsXLg className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="sm:flex sm:items-start">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <BsFillExclamationTriangleFill className="h-6 w-6 text-red-600" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                                UYARI!
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Seçili Bilim/Sanat Dalını Silmek Üzeresiniz. Emin misiniz?
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                                            onClick={() =>
                                                handleForm2Delete()
                                            }
                                        >
                                            Evet
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => {
                                                setForm2Sil(false)
                                                setBilimSanatDaliSelectedId()
                                            }}
                                        >
                                            İptal
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}

export default Tanimlar;
